import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import toastMessage from './plugins/ToastMessage'
import VueResource from 'vue-resource'
import preview from './plugins/preview'
import Video from 'video.js'
import 'video.js/dist/video-js.css'
import allReady from './utils/platForm'
import iosCordova from './utils/contentCenterCordova'
import { isiOS, isArd, isHM, isPC, isWKCordova, isMideaConnect} from './utils/utils'
import { i18n } from './i18n'
import dataRanger from './service/data-rangers/index'
import platform from './platform'
// import vconsole from 'vconsole'

// new vconsole()
// console.log(process.env.NODE_ENV)
Vue.config.ignoredElements = ['wx-open-launch-app']
Vue.prototype.$video = Video
// import preview from 'vue-photo-preview'
// import 'vue-photo-preview/dist/skin.css'
Vue.use(VueResource)
Vue.use(dataRanger)
Vue.use(preview, {
  zoomEl: isPC() === true,
  fullscreenEl: false,
  maxSpreadZoom: isPC() ? 2 : 4,
  closeOnScroll: false
})

// 对ios终端使用fastclick
/* eslint-disable */
// if (isiOS) {
//   FastClick.attach(document.body)
//   FastClick.prototype.focus = function(targetElement){
//     'use strict'
//     targetElement.focus()
//   }
// }
/* eslint-enable */

// 应用配置文件里面的接口数据

Vue.prototype.getConfigJson = function () {
  return this.$http.get('config.js')
}
Vue.config.productionTip = false
Vue.use(toastMessage)

// if (process.env.NODE_ENV === 'development') {
//   window.userId = 'lidh14'
//   window.token = 'TV53880415788236800'
// }

// 对美信iOS内置浏览器的UIWebview做兼容图片预览，消除fixed布局Bug的影响
if (isiOS() && !isWKCordova() && isMideaConnect()) {
  allReady.then(res => {
    console.log(res)
  })
}
router.beforeEach((to, from, next) => {
  if (to.path.indexOf('/content') > -1) {
    console.log(window.location.href)
    console.log(window.location.href.indexOf('defaultHeader=1'))
    console.log(!(window.location.href.indexOf('defaultHeader=1') > -1))
    const isInIfream = window.self !== window.top
    console.log('是否在ifream中--', isInIfream ? '是': '否')
    if ((isiOS() || isArd()) && isMideaConnect() && !isInIfream) {
      iosCordova.getDeviceInfo().then(res => {
        console.log(res)
      })
    }
    if (isiOS() && isMideaConnect() && !(window.location.href.indexOf('defaultHeader=1') > -1 || window.location.href.indexOf('materialListByTag') > -1) && !isInIfream) {
      console.log('iostext1')
      setTimeout(() => {
        iosCordova.contentCenterCordovaReady().then(res => {
          console.log('contentCenterCordovaReady Res---', res)
        })
          .catch(err => {
            console.log('contentCenterCordovaReady Err---', err)
          })
      }, 1000)
    } else if (!isInIfream && isiOS() && isMideaConnect() && window.location.href.indexOf('defaultHeader=1') > -1 || window.location.href.indexOf('materialListByTag') > -1) {
      console.log('iostext2')
      setTimeout(() => {
        iosCordova.setBounces().then(res => {
          console.log('setBounces Res---', res)
        })
          .catch(err => {
            console.log('setBounces err---', err)
          })
      }, 1000)
    } else if (!isInIfream && (isArd() || isHM()) && isMideaConnect() && !(window.location.href.indexOf('defaultHeader=1') > -1 || window.location.href.indexOf('materialListByTag') > -1)) {
      document.addEventListener('deviceready', function () {
        platform.hideNav().then(res => {
          console.log(res)
          console.log('调用hideNav成功')
        })
      }, false)
    } else {
      console.log('PC')
    }
  }
  next()
})
new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
